export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  PRODUCTS: "/products",
  CUSTOMERS: "/customers",
  VENDORS: "/vendors",
  TRANSACTIONS: "/transactions",
  SOLD_PERMISSION: "/sold-permission",
  ADDITION_PERMISSION: "/addition-permission",
  SOLD_INVOICES: "/sold-invoices",
  ADDITION_INVOICES: "/addition-invoices",
  INVOICE_DETAILS: ":invoiceNumber",
  PRODUCT_INVOICES: ":productId",
  CUSTOMER_INVOICES: ":customerId",
};
